import { render, staticRenderFns } from "./CollectionHero.vue?vue&type=template&id=ccf89ace"
import script from "./CollectionHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionHero.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports